export const FETCH_CO_REPORTERS = "[MIS] FETCH_CO_REPORTERS";
export const FETCH_CO_REPORTERS_START = "[MIS] FETCH_CO_REPORTERS_START";
export const FETCH_CO_REPORTERS_SUCCESS = "[MIS] FETCH_CO_REPORTERS_SUCCESS";
export const FETCH_CO_REPORTERS_ERROR = "[MIS] FETCH_CO_REPORTERS_ERROR";

export const SET_CO_REPORTERS_FILTER = "[MIS] SET_CO_REPORTERS_FILTER";

export const fetchCoReporters = (reportId) => {
    return {
        type: FETCH_CO_REPORTERS,
        reportId
    };
};


